import React from 'react'
import { Card, CardContent, CardHeader, Label, Switch } from '@/shared/ui'
import { getThermometerMemberVisible, setThermometerMemberVisible } from '../services/thermometerFeatureService'
import { useToast } from '@/shared/ui/Toast'

export default function ChartThermometerSettings() {
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [enabled, setEnabled] = React.useState(false)
  const { add: toast } = useToast()

  React.useEffect(() => {
    let mounted = true
    getThermometerMemberVisible()
      .then((on) => { if (mounted) setEnabled(on) })
      .catch((e) => toast({ title: 'Termômetro', description: e?.message || 'Falha ao carregar', variant: 'error' }))
      .finally(() => { if (mounted) setLoading(false) })
    return () => { mounted = false }
  }, [])

  async function handleToggle(next: boolean) {
    if (saving) return
    setSaving(true)
    try {
      await setThermometerMemberVisible(next)
      setEnabled(next)
      toast({ title: 'Termômetro', description: next ? 'Visível para membros' : 'Oculto para membros', variant: 'success', soft: true })
    } catch (e: any) {
      toast({ title: 'Termômetro', description: e?.message || 'Falha ao salvar', variant: 'error' })
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card>
      <CardHeader className="text-base font-semibold">Termômetro — visibilidade para Membros</CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4 text-sm text-foreground/80">
          <div>
            Quando desativado, membros verão o termômetro em cinza com a mensagem “Recurso será liberado em breve!”.
          </div>
          <div className="flex items-center gap-2">
            <Label>Oculto</Label>
            <Switch checked={enabled} onChange={(e)=> handleToggle((e.target as HTMLInputElement).checked)} disabled={loading || saving} />
            <Label>Visível</Label>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

